import { cbHttp } from "./http.service";
import { z } from "zod";
import { PackagesSchema } from "@/schemas/packages.schema";
import { DeploymentVersionSchema } from "@/schemas/versions.schema";

export const getVersions = async (): Promise<z.infer<typeof DeploymentVersionSchema>[]> => {
    return cbHttp.get('/api/deployment/versions');
}

export const getPackages = async (): Promise<z.infer<typeof PackagesSchema>[]> => {
    return cbHttp.get('/api/deployment/packages');
}

export const deploymentAvailaility = async (): Promise<boolean> => {
    return cbHttp.get('/api/deployment/deploymentavailaility');
}

export const postCreatedomain = async (data: FormData): Promise<unknown> => {
    return await cbHttp.post('/api/deployment/createdomain', data);
}

export const postCreatedatabase = async (data: FormData): Promise<unknown> => {
    return await cbHttp.post('/api/deployment/createdatabase', data);
}

export const postDeployment = async (data: FormData): Promise<unknown> => {
    return await cbHttp.post('/api/deployment/initiatedeployment', data);
}

export const postCleanup = async (data: FormData): Promise<unknown> => {
    return await cbHttp.post('/api/deployment/cleanup', data);
}

export const postChangepermissions = async (data: FormData): Promise<unknown> => {
    return await cbHttp.post('/api/deployment/changepermissions', data);
}